import { darken, setLightness } from 'polished';

const grey20 = `#ececed`;
const grey10 = `#f8f9fa`;
// const grey90 = `#232129`;
const grey100 = `#3c414a`;
const black80 = `#1B1F23`;
const white = `#fff`;
// const lightWhite = `rgba(255, 255, 255, 0.86)`;
const opaqueLightYellow = `rgba(255, 229, 100, 0.2)`;
// const opaqueLightWhite = `hsla(0, 0%, 100%, 0.2)`;
const lightGray = `hsla(0, 0%, 0%, 0.2)`;

const primary = '#8253b1';
const primaryHover = darken(0.1)(primary);

export default {
  text: grey100,
  background: white,
  light: grey10,
  onLight: grey100,
  medium: grey20,
  onMedium: black80,
  dark: black80,
  onDark: white,
  primary,
  onPrimary: white,
  primaryHover,
  primaries: [
    setLightness(0.95)(primary),
    setLightness(0.9)(primary),
    setLightness(0.8)(primary),
    setLightness(0.7)(primary),
    setLightness(0.6)(primary),
  ],

  secondary: black80,
  muted: lightGray,
  highlight: opaqueLightYellow,
  heading: grey100,
  modes: {
    dark: {},
  },

  // Not needed because we won't use code-highlighting in the default theme.
  // prism: {
  //   background: `#011627`,
  //   comment: `#809393`,
  //   string: `#addb67`,
  //   var: `#d6deeb`,
  //   number: `#f78c6c`,
  //   constant: `#82aaff`,
  //   punctuation: `#c792ea`,
  //   className: `#ffc98b`,
  //   tag: `#ffa7c4`,
  //   boolean: `#ff5874`,
  //   property: `#80cbc4`,
  //   namespace: `#b2ccd6`,
  //   highlight: `hsla(207, 95%, 15%, 1)`,
  // },
};
